<h3 *ngIf="data == null" modal-title>
    Cadastrar Item Painel</h3>
<h3 *ngIf="data != null" modal-title>
    Alterar Item do Painel
</h3>

<div 
    modal-body  
    mat-dialog-content
>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Estratégia</mat-label>
                <mat-select
                    placeholder="Estratégia"
                    [(value)]="model.estrategia_id" 
                    [formControl]="estrategia_id"                                            
                    name="estrategia_id"
                >
                    <mat-option value="">Selecione...</mat-option>
                    <mat-option 
                        *ngFor="let estrategia of listEstrategia" 
                        [value]="estrategia.id"
                    >
                        {{estrategia.nome}}
                    </mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                <mat-error *ngIf="estrategia_id.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>
    </div>
    
    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <div fxFlex.gt-sm="49%">
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Data de Inicio</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker" 
                    [formControl]="data_inicio"                     
                    name="data_inicio" 
                    placeholder="Data de Inicio"
                >
                <mat-datepicker-toggle matSuffix [for]="picker">                    
                </mat-datepicker-toggle>                
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="data_inicio.invalid">{{getErrorDataMessage()}}</mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="49%">
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Ativo</mat-label>
                <input 
                    matInput 
                    placeholder="Digite o ativo" 
                    aria-label="Ativo"
                    [formControl]="ativo" 
                    name="ativo" 
                    [matAutocomplete]="auto2"
                >
                
                <mat-autocomplete 
                    #auto2="matAutocomplete" 
                    [displayWith]="displayFnAtivo"  
                    (optionSelected)='getAtivo($event.option.value)'
                >
                    <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                        <span>Empresa: {{ativo.nome}}</span> |
                        <small>Sigla: {{ativo.sigla }}</small>
                    </mat-option>
                </mat-autocomplete>            
                <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
                <mat-error *ngIf="rv_clientes_qtd_enviados.invalid">{{getErrorNameMessage(this.ativo)}}</mat-error>
            </mat-form-field> 
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <div fxFlex.gt-sm="49%">
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Qtd. Cliente Enviados</mat-label>
                <input 
                    matInput 
                    required
                    type="number"
                    placeholder="Qtd. Cliente Enviados" 
                    [formControl]="rv_clientes_qtd_enviados"                     
                    maxlength="100"
                />
                <mat-error *ngIf="rv_clientes_qtd_enviados.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="49%">
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Qtd. Cliente Efetivados</mat-label>
                <input 
                    matInput 
                    required
                    type="number"
                    placeholder="Qtd. Cliente Efetivados" 
                    [formControl]="rv_clientes_qtd_efetivados"                     
                    maxlength="100"
                />
                <mat-error *ngIf="rv_clientes_qtd_enviados.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <div fxFlex.gt-sm="49%">
            
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Volume Enviado</mat-label>
                <input 
                    matInput 
                    required                   
                    placeholder="Volume Enviado" 
                    [formControl]="rv_volume_enviado"                     
                    maxlength="100"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                />
                <mat-error *ngIf="rv_clientes_qtd_enviados.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="49%">          
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Volume Efetivado</mat-label>
                <input 
                    matInput 
                    required                    
                    placeholder="Volume Efetivado" 
                    [formControl]="rv_volume_efetivado"                     
                    maxlength="100"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                />
                <mat-error *ngIf="rv_clientes_qtd_enviados.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <div fxFlex.gt-sm="33%">
            
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Ativo: Preço Compra</mat-label>
                <input 
                    matInput 
                    required                   
                    placeholder="R$ 0,00" 
                    [formControl]="ativo_preco_compra"                     
                    maxlength="20"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                />
                <mat-error *ngIf="ativo_preco_compra.invalid"></mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="33%">          
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Ativo: Preço Alvo Corretora</mat-label>
                <input 
                    matInput 
                    required                    
                    placeholder="R$ 0,00" 
                    [formControl]="ativo_preco_alvo_corretora"                     
                    maxlength="20"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                />
                <mat-error *ngIf="ativo_preco_alvo_corretora.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="33%">          
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Ativo: Preço Saída Escritório</mat-label>
                <input 
                    matInput                                       
                    placeholder="R$ 0,00" 
                    [formControl]="ativo_preco_alvo_escritorio"                     
                    maxlength="20"
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                />
                <mat-error *ngIf="ativo_preco_alvo_escritorio.invalid">Campo obrigatório.</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <div fxFlex.gt-sm="33%">
            
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>% da Proteção</mat-label>
                <input 
                    matInput                                        
                    placeholder="0,00 %" 
                    [formControl]="valor_protecao"                     
                    maxlength="9"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }"
                />                
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="33%">          
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>% dos Proventos</mat-label>
                <input 
                    matInput                                         
                    placeholder="0,00 %" 
                    [formControl]="valor_proventos"                     
                    maxlength="9"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }"
                />                
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="33%">          
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>% dos Premios</mat-label>
                <input 
                    matInput                                        
                    placeholder="0,00 %" 
                    [formControl]="valor_premio"                     
                    maxlength="9"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }"
                />                
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">

        <div fxFlex.gt-sm="33%">          
            <mat-form-field 
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Data da Saída</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="pickerDateFim" 
                    [formControl]="data_fim"                     
                    name="data_fim" 
                    placeholder="Data de Fim"
                >
                <mat-datepicker-toggle matSuffix [for]="pickerDateFim">                    
                </mat-datepicker-toggle>                
                <mat-datepicker #pickerDateFim></mat-datepicker>                
            </mat-form-field>
        </div>
        
        <div fxFlex.gt-sm="33%">
            
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>Qtd. Dias Trade</mat-label>
                <input 
                    matInput                                        
                    placeholder="Qtd Dias Trades"
                    [formControl]="qtd_dias_trade"
                    maxlength="100"
                />                
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="33%">          
            <mat-form-field
                appearance="outline" 
                floatLabel="always" 
                fxFlex="100"
            >
                <mat-label>% da Perfomance</mat-label>
                <input 
                    matInput                     
                    placeholder="% da Perfomance" 
                    [formControl]="valor_perfomance"                     
                    maxlength="100"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }"
                />                
            </mat-form-field>
        </div>
    </div>

    
</div>

<div mat-dialog-actions model-footer>    
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >   
        Cancelar
    </button>
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>


